/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {SortDirection} from '../models/SortDirection';
import type {UpdateColumnRequest} from '../models/UpdateColumnRequest';
import type {UpdateTemplateRequest} from '../models/UpdateTemplateRequest';
import type {UpdateTemplateResponse} from '../models/UpdateTemplateResponse';

export interface CreateSearchTemplate$Request {
    updateTemplateRequest?: UpdateTemplateRequest;
}

export interface CreateSearchTemplate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createSearchTemplateRequest = createAction<PayloadData<void, CreateSearchTemplate$Request>>('SEARCH_TEMPLATE__CREATE_SEARCH_TEMPLATE__REQUEST');
export const createSearchTemplateSuccess = createAction<PayloadData<UpdateTemplateResponse, CreateSearchTemplate$Request>>('SEARCH_TEMPLATE__CREATE_SEARCH_TEMPLATE__SUCCESS');
export const createSearchTemplateFailure = createAction<PayloadData<Error, CreateSearchTemplate$Request, true>>('SEARCH_TEMPLATE__CREATE_SEARCH_TEMPLATE__FAILURE');

export const createSearchTemplateActions = [
    createSearchTemplateRequest,
    createSearchTemplateSuccess,
    createSearchTemplateFailure
] as const;

/**
 * @param {UpdateTemplateRequest} [meta.updateTemplateRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createSearchTemplate = (meta: CreateSearchTemplate$Request, config?: CreateSearchTemplate$Config) => {
    return {
        CALL_API: {
            types: createSearchTemplateActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/search-templates`,
            TRANSPORT_REQUEST_BODY: meta.updateTemplateRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DeleteSearchTemplate$Request {
    templateId: number;
}

export interface DeleteSearchTemplate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteSearchTemplateRequest = createAction<PayloadData<void, DeleteSearchTemplate$Request>>('SEARCH_TEMPLATE__DELETE_SEARCH_TEMPLATE__REQUEST');
export const deleteSearchTemplateSuccess = createAction<PayloadData<void, DeleteSearchTemplate$Request>>('SEARCH_TEMPLATE__DELETE_SEARCH_TEMPLATE__SUCCESS');
export const deleteSearchTemplateFailure = createAction<PayloadData<Error, DeleteSearchTemplate$Request, true>>('SEARCH_TEMPLATE__DELETE_SEARCH_TEMPLATE__FAILURE');

export const deleteSearchTemplateActions = [
    deleteSearchTemplateRequest,
    deleteSearchTemplateSuccess,
    deleteSearchTemplateFailure
] as const;

/**
 * @param {number} meta.templateId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteSearchTemplate = (meta: DeleteSearchTemplate$Request, config?: DeleteSearchTemplate$Config) => {
    return {
        CALL_API: {
            types: deleteSearchTemplateActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/search-templates/${meta.templateId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateColumnOrder$Request {
    templateId: number;
    updateColumnRequest?: UpdateColumnRequest;
}

export interface UpdateColumnOrder$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateColumnOrderRequest = createAction<PayloadData<void, UpdateColumnOrder$Request>>('SEARCH_TEMPLATE__UPDATE_COLUMN_ORDER__REQUEST');
export const updateColumnOrderSuccess = createAction<PayloadData<void, UpdateColumnOrder$Request>>('SEARCH_TEMPLATE__UPDATE_COLUMN_ORDER__SUCCESS');
export const updateColumnOrderFailure = createAction<PayloadData<Error, UpdateColumnOrder$Request, true>>('SEARCH_TEMPLATE__UPDATE_COLUMN_ORDER__FAILURE');

export const updateColumnOrderActions = [
    updateColumnOrderRequest,
    updateColumnOrderSuccess,
    updateColumnOrderFailure
] as const;

/**
 * @param {number} meta.templateId
 * @param {UpdateColumnRequest} [meta.updateColumnRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateColumnOrder = (meta: UpdateColumnOrder$Request, config?: UpdateColumnOrder$Config) => {
    return {
        CALL_API: {
            types: updateColumnOrderActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/search-templates/${meta.templateId}/columns`,
            TRANSPORT_REQUEST_BODY: meta.updateColumnRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateDefaultSorting$Request {
    templateId: number;
    sortColumn: string;
    sortDirection: SortDirection;
}

export interface UpdateDefaultSorting$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateDefaultSortingRequest = createAction<PayloadData<void, UpdateDefaultSorting$Request>>('SEARCH_TEMPLATE__UPDATE_DEFAULT_SORTING__REQUEST');
export const updateDefaultSortingSuccess = createAction<PayloadData<void, UpdateDefaultSorting$Request>>('SEARCH_TEMPLATE__UPDATE_DEFAULT_SORTING__SUCCESS');
export const updateDefaultSortingFailure = createAction<PayloadData<Error, UpdateDefaultSorting$Request, true>>('SEARCH_TEMPLATE__UPDATE_DEFAULT_SORTING__FAILURE');

export const updateDefaultSortingActions = [
    updateDefaultSortingRequest,
    updateDefaultSortingSuccess,
    updateDefaultSortingFailure
] as const;

/**
 * @param {number} meta.templateId
 * @param {string} meta.sortColumn
 * @param {SortDirection} meta.sortDirection
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateDefaultSorting = (meta: UpdateDefaultSorting$Request, config?: UpdateDefaultSorting$Config) => {
    const TRANSPORT_GET_PARAMS = {
        sortColumn: meta.sortColumn,
        sortDirection: meta.sortDirection,
    };
    return {
        CALL_API: {
            types: updateDefaultSortingActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/search-templates/${meta.templateId}/sorts`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateSearchTemplateName$Request {
    templateId: number;
    templateName: string;
}

export interface UpdateSearchTemplateName$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateSearchTemplateNameRequest = createAction<PayloadData<void, UpdateSearchTemplateName$Request>>('SEARCH_TEMPLATE__UPDATE_SEARCH_TEMPLATE_NAME__REQUEST');
export const updateSearchTemplateNameSuccess = createAction<PayloadData<void, UpdateSearchTemplateName$Request>>('SEARCH_TEMPLATE__UPDATE_SEARCH_TEMPLATE_NAME__SUCCESS');
export const updateSearchTemplateNameFailure = createAction<PayloadData<Error, UpdateSearchTemplateName$Request, true>>('SEARCH_TEMPLATE__UPDATE_SEARCH_TEMPLATE_NAME__FAILURE');

export const updateSearchTemplateNameActions = [
    updateSearchTemplateNameRequest,
    updateSearchTemplateNameSuccess,
    updateSearchTemplateNameFailure
] as const;

/**
 * @param {number} meta.templateId
 * @param {string} meta.templateName
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateSearchTemplateName = (meta: UpdateSearchTemplateName$Request, config?: UpdateSearchTemplateName$Config) => {
    const TRANSPORT_GET_PARAMS = {
        templateName: meta.templateName,
    };
    return {
        CALL_API: {
            types: updateSearchTemplateNameActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/search-templates/${meta.templateId}`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

